import { Box, Chip, Grid, Typography, styled } from "@mui/material";
import { findObjectKeyByValue } from "../../../utils/helper";
import { WAY_OF_CONFIRMATION } from "../../../utils/beneficiary.constant";
import ImageComponent from "../../../components/inputs/ImageComponent";
import { DEVICES, DEVICES_NAME } from "../../../utils/constants";
import AccordionDetailsUi from "../../../components/layouts/common/AccordionDetailsUi";
import neckbandBlack from "../../../assets/images/neckband.svg";
import itePrimeWhite from "../../../assets/images/ITE_PRIME_WHITE.svg";
import iteOptimaBlack from "../../../assets/images/ITE_OPTIMA_BLACK.svg";
import METALIC_RIC_OPTIMA from "../../../assets/images/metalic_ric.svg";
import ric8WithoutDome from "../../../assets/images/WITHOUT DOME.svg";
import BTE from "../../../assets/images/Frame_34320[1].png";
import wehearox from "../../../assets/images/wehearox.svg";
import SAFE_BUDS from "../../../assets/images/safebuds.svg";
import wehear_2_0 from "../../../assets/images/wehear 2 0.svg";
const Header = styled(Box)(({ theme }) => ({
  border: "1px solid " + theme.palette.primary.main,
  padding: theme.spacing(2),
  background: theme.palette.secondary.main,
  borderTopLeftRadius: theme.shape.borderRadius * 2,
  borderBottom: "0px",
  borderTopRightRadius: theme.shape.borderRadius * 2,
  width: "100%",
}));
const Body = styled(Box)(({ theme }) => ({
  border: "1px solid " + theme.palette.primary.main,
  padding: theme.spacing(2),

  marginBottom: theme.spacing(2),

  borderBottomLeftRadius: theme.shape.borderRadius * 2,
  borderBottomRightRadius: theme.shape.borderRadius * 2,
  width: "100%",
}));

const SuggetstedProductDetails = ({ data }) => {

  const SuggestedProductData = (productType) => {

    const baseConfig = {
      border: data?.device === productType,
      backgroundColor: data?.device === productType,
    };

    switch (productType) {
      case DEVICES.BTE_OPTIMA:
        return {
          ...baseConfig,
          src: BTE,
          // OnClickCenter: () => updateSuggestedProduct(DEVICES.BTE_OPTIMA),
        };

      case DEVICES.BTE_PRIME:
        return {
          ...baseConfig,
          src: BTE,
          // OnClickCenter: () => updateSuggestedProduct(DEVICES.BTE_PRIME),
        };

      case DEVICES.RIC_OPTIMA_8:
        return {
          ...baseConfig,
          src: ric8WithoutDome,
          // OnClickCenter: () => updateSuggestedProduct(DEVICES.RIC_OPTIMA_8),
        };

      case DEVICES.RIC_OPTIMA:
        return {
          ...baseConfig,
          src: METALIC_RIC_OPTIMA,
          sideColor: {
            METALIC: "#C6C1C5",
            BLACK: "#000000",
            BEIGE: "#D6B19F",
          },
          // OnClickCenter: () => updateSuggestedProduct(DEVICES.RIC_OPTIMA),
        };

      case DEVICES.RIC_32:
        return {
          ...baseConfig,
          src: METALIC_RIC_OPTIMA,
          sideColor: {
            METALIC: "#C6C1C5",
            BLACK: "#000000",
            BEIGE: "#D6B19F",
          },
          // OnClickCenter: () => updateSuggestedProduct(DEVICES.RIC_32),
        };

      case DEVICES.ITE_OPTIMA:
        return {
          ...baseConfig,
          src: iteOptimaBlack,
          sideColor: { BLACK: "#000000", WHITE: "#FFFFFF" },
          // OnClickCenter: () => updateSuggestedProduct(DEVICES.ITE_OPTIMA),
        };

      case DEVICES.ITE_PRIME:
        return {
          ...baseConfig,
          src: itePrimeWhite,
          // OnClickCenter: () => updateSuggestedProduct(DEVICES.ITE_PRIME),
        };

      case DEVICES.NECKBAND:
        return {
          ...baseConfig,
          src: neckbandBlack,
          IsOnlyBoth: "OnlyBoth",
          // OnClickCenter: () => updateSuggestedProduct(DEVICES.NECKBAND),
        };
      case DEVICES.WEHEAR_OX:
        return {
          ...baseConfig,
          src: wehearox,
          // OnClickCenter: () => updateSuggestedProduct(DEVICES.WEHEAR_OX),
        };
      case DEVICES.SAFE_BUDS:
        return {
          ...baseConfig,
          src: SAFE_BUDS,
          // OnClickCenter: () => updateSuggestedProduct(DEVICES.SAFE_BUDS),
        };
      case DEVICES.WEHEAR_2_0:
        return {
          ...baseConfig,
          src: wehear_2_0,
          // OnClickCenter: () => updateSuggestedProduct(DEVICES.WEHEAR_2_0),
        };

      default:
        return {};
    }
  };
  console.log("DATAeeee", data);
  return (
    <>
      <Header>
        <Typography fontWeight="bold" variant="body1">
          Suggested Product Details
        </Typography>
      </Header>

      <Body>
        <Grid container spacing={2}>
          {/* Suggested Products List */}
          <Grid item xs={12}>
            <Grid container spacing={2}>
              {data?.suggestedProduct?.map((item, idx) => {
                const productData = SuggestedProductData(item);
                return (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={2.4}
                    key={`${item}- ${ idx }`
              }
                    sx = {{
                display: "flex",
                justifyContent: "center",
              }}
                  >
              <AccordionDetailsUi
                side={productData?.IsOnlyBoth ?? item.side}
                Title={DEVICES_NAME[item]}
                sideColor={productData?.sideColor}
                isBorder={productData?.border}
                isBackgroundColor={productData?.backgroundColor}
                img_src={productData?.src}
                device={item}
              />
            </Grid>
            );
              })}
          </Grid>
        </Grid>

        {/* Product Info Section */}
        {/* <Grid item xs={12}>
        <Box
          mt={3}
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            // justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 1.5,
            flexWrap: "wrap",
          }}
        >
          <Typography
            fontWeight="bold"
            variant="body2"
            sx={{ minWidth: { xs: "100%", sm: "auto" } }}
          >
            Product :
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 1,
            }}
          >
            {data?.suggestedProduct?.length > 0 ? (
              data?.suggestedProduct.map((item) => (
                <Chip
                  key={item?.id}
                  label={findObjectKeyByValue(item, DEVICES)}
                  size="small"
                  sx={{
                    fontSize: "0.8rem",
                    borderRadius: "8px",
                  }}
                />
              ))
            ) : (
              <Typography variant="body2">NA</Typography>
            )}
          </Box>
        </Box>
      </Grid> */}
      </Grid>
    </Body >
    </>

  );
};
export default SuggetstedProductDetails;